const favorites = {};

// get favorites from local storage or empty array
let storedfavs = JSON.parse(localStorage.getItem('storedfavs')) || [];

// get all post data from ids
function sendAjax(storedfavs) {
	$.ajax({
		url: customData.ajaxURL,
		data: {
			action: 'favorite_selection',
			favs: storedfavs
		},
		method: 'POST',
		success: function (response) {
			if (storedfavs.length > 0 && document.querySelector(".favorites--counter")) document.querySelector(".favorites--counter").appendChild(document.createTextNode(`(${storedfavs.length})`));
			$.each(response, function (i, item) {
				createFavItem(item);
			});
		},
		error: function (error) { console.log(error) }
	})
}

//create the cards
function createFavItem(data) {
//console.log(data);
	var image = data.image;
	if (image === null) {
		image = data.placeholder;
	}

	var icon;
	if (data.hasOwnProperty("icon") && typeof data.icon !== "undefined") {
		icon = data.icon;
	} else {
		icon = "";
	}

	var favItem = `
	<a href="${data.url}" class="course-item">
		<div class="course-item-image">
			<div class="image">
				<img src="${image}" alt="${data.image_alt}" data-align="middle center" data-loader="false"/>
			</div>
			${icon && `<div class="filter-icon-container"><img src="${icon}" class="filter-icon"></div>`}
		</div>
		<div class="course-item-content">
			<h2 class="small">${data.title}</h2>
			<i class="svg-icon loaded" data-icon="icon-arrow" data-fill="#00AEF0" id="svg-icon-14"><svg x="0px" y="0px" width="100%" height="100%" viewBox="19 15.4 7.7 13.4" style="transform: translateZ(0px);"><g id="icon-arrow" fill="#00AEF0">
      <path d="M23,19 L16,19 C15.4477153,19 15,18.5522847 15,18 C15,17.4477153 15.4477153,17 16,17 L23,17 L24,17 C24.5522847,17 25,17.4477153 25,18 L25,26 C25,26.5522847 24.5522847,27 24,27 C23.4477153,27 23,26.5522847 23,26 L23,19 Z" id="Combined-Shape" transform="translate(20.000000, 22.000000) rotate(-315.000000) translate(-20.000000, -22.000000) " fill="#00AEF0"></path>
    </g></svg></i>
	 <span class="genre">${data.posttype}</span>
		</div>
	</a>`;
	$(".js-favlist").append(favItem);
}

//copied from filter.js
function getUrlVars() {
	var vars = {};
	var parts = window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function (m, key, value) {
		vars[key] = value.split('+');
	});
	return vars;
}

// add single education item to localStorage
function addToFavs(item) {

	var id = item.getAttribute('data-id'),
		index = storedfavs.indexOf(id);

	// the most ugly hack ever to make heart icons working
	document.querySelectorAll(".js-makefavorite .svg-icon.loaded").forEach((el) => {
		el.removeAttribute("style")
	});

	// return if target doesn't have an id (shouldn't happen)
	if (!id) return;
	// item is not favorite
	if (index == -1) {
		storedfavs.push(id);
		item.classList.toggle('fav');

		// item is already favorite
	} else {
		storedfavs.splice(index, 1);
		item.classList.toggle('fav');
	}

	// store array in local storage
	localStorage.setItem('storedfavs', JSON.stringify(storedfavs));

}

function iconClose(){
	document.querySelectorAll('.js-icon-close').forEach((el) => {
			el.addEventListener("click", (e) => {
				e.preventDefault();
				document.querySelector('.js-favalert').classList.remove('favorites--alert__active');
				$(".favorites--alert-content").empty();
			});
	});
}

function clearFavorites(){
	document.querySelectorAll('.js-clearFavs').forEach((el) => {
			el.addEventListener("click", (e) => {
				e.preventDefault();
				localStorage.clear();
				document.querySelector('.js-favalert').classList.remove('favorites--alert__active');
				$(".favorites--alert-content").empty();
				window.location.reload();
			});
	});
}

function sendToPlannedCulture(){
	// on click "ga door naar planned culture" create url and open new window
		document.querySelectorAll('.js-submitfavs').forEach((el) => {
			el.addEventListener("click", (e) => {
				e.preventDefault();
				let url = 'https://kubus-scala.plannedculture.nl/';

				storedfavs.forEach((item, i) => {
					if (i == 0) {
						url += '?activity_ids=' + item;
					} else {
						url += ',' + item;
					}
				})
				url += '&fav_mode=add';

				window.open(url, '_blank');
				window.focus();
			});
		});

}


favorites.init = function () {

	// add or remove single education to favorites
	document.querySelectorAll('.js-makefavorite').forEach((el) => {

		var id = el.getAttribute('data-id');
		if (storedfavs.indexOf(id) !== -1) {
			el.classList.add('fav');
		}

		el.addEventListener('click', function (e) {
			addToFavs(el);
		});
	});


	// the favorites page with collected items
	if (document.body.contains(document.querySelector(".js-favorites"))) {

		const extratitle = document.querySelector('.extratitle');
		const shareform = document.querySelector('.js-emailfavs');
		const mailbtn = document.querySelector('.mailfavorites');
		const sendbtn = document.querySelector('.js-sendfavs');
		const clear = document.querySelector('.clearfavorites');


		const urlParams = getUrlVars();

		// get post data from items based on ids in url (shared option)
		if ((Object.entries(urlParams).length !== 0 || urlParams.constructor !== Object) && urlParams.hasOwnProperty('ids')) {

			extratitle.innerHTML = 'Dit zijn gedeelde favorieten. Bekijk <a href="/favorieten/">hier</a> je eigen favorietenlijst.';
			shareform.style.display = 'none';
			sendbtn.style.display = 'none';
			mailbtn.style.display = 'none';
			clear.style.display = 'none';
			let urlFavs = Object.values(urlParams)[0];

			sendAjax(urlFavs);
		}

		// get post data from items in local storage
		if (Object.entries(urlParams).length === 0) {

			if (storedfavs.length === 0) {
				extratitle.innerHTML = 'Er zijn nog geen favorieten opgeslagen. Bekijk <a href="/onderwijs-aanbod/">hier</a> het onderwijsaanbod.';
				shareform.style.display = 'none';
				sendbtn.style.display = 'none';
				mailbtn.style.display = 'none';
				clear.style.display = 'none';
			}

			sendAjax(storedfavs);
		}


		// on click "inschrijven" open pop-up
		document.querySelectorAll('.js-sendfavs').forEach((el) => {
			el.addEventListener("click", (e) => {
				e.preventDefault();
				// check deadline 15th of june each year
				let obj = new Date();
				let day = obj.getUTCDate();
				let month = obj.getUTCMonth() + 1;

				let subscribe = true;
				if ( month > 6 || ( month == 6 && day > 15 )){
					subscribe = false;
				}

				if ( subscribe ){
				$(".favorites--alert-content").append(
					`<i class="svg-icon js-icon-close" data-icon="icon-close" data-fill="#000"></i>
					<p>Zijn de favorieten gekozen en wil je inschrijven? Log dan hier in.</p>
					<span class="btn btn--black js-submitfavs" >Ga door naar de inschrijfpagina<i class="svg-icon" data-icon="icon-arrow" data-fill="#fff"></i></span>`
				);
				} else {
				$(".favorites--alert-content").append(
					`<i class="svg-icon js-icon-close" data-icon="icon-close" data-fill="#000"></i>
					<p>Helaas is de deadline (15 juni 2025) voor het inschrijven van aanbod voor het primair onderwijs verstreken. Heb je nog een dringende wens voor het seizoen 2025-2026? Neem dan contact op met de coördinator cultuureducatie van De Kubus of met de afdeling Planning via <a href="mailto:planning@dekubuslelystad.nl">planning@dekubuslelystad.nl</a>. Alvast bedankt!</p>
					<span class="btn btn--black js-submitfavs" >Ga door naar de inschrijfpagina<i class="svg-icon" data-icon="icon-arrow" data-fill="#fff"></i></span>`
				);
				}

				document.querySelector('.js-favalert').classList.add('favorites--alert__active');
				$(".js-favalert").icons.init(".svg-icon");

				iconClose();
				sendToPlannedCulture();

			});
		});

				// on click "inschrijven" open pop-up
		document.querySelectorAll('.clearfavorites').forEach((el) => {
			el.addEventListener("click", (e) => {
				e.preventDefault();

				$(".favorites--alert-content").append(
					`<i class="svg-icon js-icon-close" data-icon="icon-close" data-fill="#000"></i>
					<h4>Let op!</h4>
					<p>Hiermee wis je al je opgeslagen favorieten.</p>
					<span class="btn btn--black js-clearFavs" >Wis alle favorieten<i class="svg-icon" data-icon="icon-arrow" data-fill="#fff"></i></span>`
				);
				document.querySelector('.js-favalert').classList.add('favorites--alert__active');
				$(".js-favalert").icons.init(".svg-icon");

				iconClose();
				clearFavorites();

			});
		});
	}

	// all code below is used to mail favorites
	var sharefavorites = {
		$this: $('.js-emailfavs')
	};



	let count_input = 0;
	document.querySelectorAll('.add_input').forEach((el) => {
		el.addEventListener("click", (e) => {
			e.preventDefault();
			count_input ++;
			var element = document.createElement("input");
			element.setAttribute("type", "email");
			element.setAttribute("placeholder", "E-mailadres ontvanger");
			element.setAttribute("name",  "email_to_" + count_input );
			var container = document.getElementById('maildiv');
			container.appendChild(element);
		})
	})

	var submitting_sharefavorites_form = false;
	var refresh = false;

	sharefavorites.$this.submit(function (e) {
		e.preventDefault();

		//prevent multiple submits
		if (submitting_sharefavorites_form) {
			return false;
		}
		submitting_sharefavorites_form = true;

		var $form = sharefavorites.$this.find('form');
		var submit_btn = $form.find('button[type="submit"]');


		let form_data = $form.serialize();

		var url = 'https://dekubuslelystad.nl/favorieten/'
		// get items from localStorage
		storedfavs.forEach(function (item, i) {
			if (i == 0) {
				url += '?ids=' + item;
			} else {
				url += '+' + item;
			}
		});


		form_data += "&url_favs=" + encodeURIComponent(url);

		$.ajax({
			url: customData.ajaxURL,
			data: form_data,
			dataType: 'json',
			method: 'POST',
		})
			.done(function (data) {

				var old_submit = sharefavorites.$this.find('button[type="submit"]').text();

				submit_btn.blur();

				if (!data.success) {

					submit_btn.unbind('hover');
					sharefavorites.$this.find('.message').html(data.message).show();

					//submit_btn.css({backgroundColor: '#ff0000', cursor: 'default'});
					submit_btn.html('Er ging iets mis');

					submit_btn.animate({ opacity: 1 });

					refresh = true;

				} else {

					submit_btn.unbind('hover');
					//submit_btn.css({backgroundColor: '#446e03', cursor: 'default'});
					submit_btn.html(data.message);
					submit_btn.animate({ opacity: 1 });
					sharefavorites.$this.find('.message').html(data.message).hide();

					submitting_sharefavorites_form = true;
					refresh = false;
				}

				//reset the button to normal state
				if (refresh) {
					setTimeout(function () {

						submit_btn.animate({ opacity: 0 }, 500, function () {

							$(this).removeAttr('style');

							submit_btn.html(old_submit);

							submit_btn.animate({ opacity: 1 }, 500, function () {

								submitting_sharefavorites_form = false;
							});
						});
					}, 2000);
				}
			});
	});
}

export { favorites };

